import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import {LauncherLinkComponent} from './launcher-link.component';
import List from '@material-ui/core/List';
import {LAUNCHER_RELATIVE_PATHS} from '../../services/routing/launcher-routing-configuration';

export class LauncherLinksComponent extends LauncherComponentBase<{}> {
    render() {
        return (
          <List>
              <LauncherLinkComponent path='/' text='Configurations'/>
              <LauncherLinkComponent path={LAUNCHER_RELATIVE_PATHS.ADD_GAMES} text='Add games'/>
              <LauncherLinkComponent path={LAUNCHER_RELATIVE_PATHS.ADD_VENDOR_GAMES} text='Add vendor games'/>
              <LauncherLinkComponent path={LAUNCHER_RELATIVE_PATHS.JSON_VIEW} text='JSON View'/>
              <LauncherLinkComponent path={LAUNCHER_RELATIVE_PATHS.BUILD_URLS} text='URLs builder'/>
          </List>
        );
    }
}